module.exports = __webpack_public_path__ + "img/color-started-icon.64c20e4b.svg";